import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import areasOfFocus from './ducks/areasOfFocus';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import contents from './ducks/contents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import currentUser from './ducks/currentUser';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import daysMap from './ducks/daysMap';
import error from './ducks/error';
import flashMessages from './ducks/flashMessages';
import gMapsError from './ducks/gMapsError';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import gradSchools from './ducks/gradSchools';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import groupDashboard from './ducks/groupDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import groups from './ducks/groups';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents from './ducks/idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import internshipFunctions from './ducks/internshipFunctions';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import invites from './ducks/invites';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import invoices from './ducks/invoices';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import jobFunctions from './ducks/jobFunctions';
import layout from './ducks/layout';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listings from './ducks/listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import mainSearch from './ducks/mainSearch';
import modal from './ducks/modal';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import orgDashboard from './ducks/orgDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import paymentMethods from './ducks/paymentMethods';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import postSearch from './ducks/postSearch';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import searchRadius from './ducks/searchRadius';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import subscribedSubsites from './ducks/subscribedSubsites';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import userDashboard from './ducks/userDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import userLocation from './ducks/userLocation';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import userNotifications from './ducks/userNotifications';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import volopFunctions from './ducks/volopFunctions';
import { reducer as orgs } from './slices/orgs';

const reducers = {
  error,
  gMapsError,
  currentUser,
  userNotifications,
  userLocation,
  paymentMethods,
  invites,
  areasOfFocus,
  jobFunctions,
  internshipFunctions,
  volopFunctions,
  orgs,
  listings,
  groups,
  idealistDayEvents,
  mainSearch,
  modal,
  layout,
  searchRadius,
  flashMessages,
  userDashboard,
  orgDashboard,
  groupDashboard,
  invoices,
  contents,
  postSearch,
  gradSchools,
  daysMap,
  subscribedSubsites,
};

export type Reducers = typeof reducers;

export const mainRootReducer = combineReducers(reducers);
